/**
 * Канонічні джерела «звідки дізналась».
 *
 * Один список на всі місця, де користувач їх обирає: картка клієнтки і
 * картка задачі «звідки дізналась». Раніше він існував лише в
 * Clients.modern.tsx, тому задача взагалі не пропонувала вибору — і
 * адмінка мусила закрити задачу загальним результатом, а потім окремо
 * лізти в профіль клієнтки й вписувати джерело руками.
 *
 * Ключі — це те, що реально лежить у Client.referralSource (instagram 59,
 * google_maps 51, recommendation 26, public 14, tiktok 12…). Міняти їх не
 * можна, інакше звіт «Джерела» роз'їдеться на старих і нових записах.
 */
export const REFERRAL_SOURCES: { key: string; label: string; emoji: string }[] = [
  { key: "instagram", label: "Instagram", emoji: "📷" },
  { key: "google_maps", label: "Google Maps", emoji: "🗺️" },
  { key: "tiktok", label: "TikTok", emoji: "🎵" },
  { key: "public", label: "Паблік", emoji: "📢" },
  { key: "recommendation", label: "Порекомендували", emoji: "🤝" },
  { key: "targeted_ads", label: "Таргет", emoji: "🎯" },
  { key: "business_card", label: "Візитка", emoji: "💳" },
  { key: "cross_marketing", label: "Крос-маркетинг", emoji: "🔁" },
];

export const REFERRAL_LABEL_MAP: Record<string, string> = Object.fromEntries(
  REFERRAL_SOURCES.map((s) => [s.key, `${s.emoji} ${s.label}`]),
);
